
<script>
    // No script needed for this component
</script>

<style>
    /* Styles moved to global.css */
</style>

<section class="partners-section">
    <div class="partners-container">
        <h2 class="partners-title">Våra Partners</h2>
        <p class="partners-description">
            Vi är stolta över att samarbeta med ledande företag för att förnya och förbättra bostadsmarknaden.
        </p>
        <div class="logos-container">
            <div class="logo-item">
                <img src="/google.webp" alt="Google for Startups logo" />
            </div>
            <div class="logo-item">
                <img src="/microsoft.png" alt="Microsoft for Startups logo" />
            </div>
        </div>
    </div>
</section>
